<template>
	<el-dialog title="提示" :visible.sync="dialogVisible" width="650px" :append-to-body="true" :before-close="handleClose">
		<div class="content">
			<template v-if="isNext">
				<div class="flex-row">
					<i class="el-icon-warning mt-4"></i>
					<div class="text">是否确认通过团长与该达人合作？</div>
				</div>
				<div class="yx-color-text-primary font-h4-regular ml-20">
					以下商品正在与对应团长/达人合作，在团队多对一按[团长]归属业绩时，若您继续寄样，业绩将无法归属，请确认是否继续?
				</div>
			</template>
			<div class="flex-row" v-else>
				<i class="el-icon-warning mt-4"></i>
				<div class="text">以下商品正在与对应达人合作，当前合作进度结束后才能继续合作！</div>
			</div>
			<el-table class="mt-16" :data="list" header-row-class-name="table-header-row" row-class-name="table-row" :span-method="objectSpanMethod">
				<el-table-column label="商品信息" width="200">
					<template v-slot="{ row }">
						<div class="product">
							<el-image :src="row.product_pic" />
							<div class="ml-8">
								<div class="flex-row-align-center">
									<platform-icon :platformId="row.platformId"></platform-icon>
									<div class="ml-4 line-ellipsis-1 yx-color-text-primary" style="max-width: 120px">{{ row.product_name }}</div>
								</div>
								<div class="font-h6-regular yx-color-text-regular">商品ID: {{ row.third_product_id }}</div>
							</div>
						</div>
					</template>
				</el-table-column>
				<el-table-column label="达人运营" width="80">
					<template v-slot="{ row }">
						<span>{{ row.username | textFormat(4) }}</span>
					</template>
				</el-table-column>
				<el-table-column label="合作团长" width="80">
					<template v-slot="{ row }">
						<span>{{ row.team_institution_name | textFormat(5) | formatEmpty }}</span>
					</template>
				</el-table-column>
				<el-table-column prop="" label="合作达人" width="120">
					<template v-slot="{ row }">
						<div class="flex-row flex-align-center">
							<YxAvatar :src="row.anchor_head" :size="24" />
							<div class="ml-4">
								<div class="ml-16 yx-color-text-primary">{{ row.anchor_name | textFormat(5) }}</div>
								<rdTag class="ml-6" :tagType="row.retail_type === '0' ? 'danger' : 'primary'">
									{{ row.retail_type_name }}
								</rdTag>
							</div>
						</div>
					</template>
				</el-table-column>
				<el-table-column label="最近申样时间" width="108">
					<template v-slot="{ row }">
						<span>{{ row.last_apply_time | formatEmpty }}</span>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<span slot="footer" v-if="isNext">
			<el-button @click="handleClose">取消</el-button>
			<el-button type="primary" @click="confirm">确认合作</el-button>
		</span>
		<span slot="footer" v-else>
			<el-button type="primary" @click="handleClose">我知道了</el-button>
		</span>
	</el-dialog>
</template>

<script>
export default {
	name: 'batchHintDialog',

	computed: {
		tagType() {
			let obj = {
				0: 'danger',
				1: '',
				2: 'warning',
			};
			return ({ type }) => obj[type];
		},
	},
	data() {
		return {
			list: [],
			dialogVisible: false,
			repets: [],
			isNext: false,
		};
	},
	methods: {
		show(list, status) {
			this.isNext = status === 2;
			this.getRepetProducts(list);
			this.list = list;
			this.dialogVisible = true;
		},
		handleClose() {
			this.list = [];
			this.repets = [];
			this.isNext = false;
			this.dialogVisible = false;
		},
		getRepetProducts(list) {
			var newArr = [...new Set(list.map(i => i.third_product_id))]; // 去重的时候需要注意和普通数组不同
			const _list = [];
			newArr.forEach(i => {
				_list.push(list.map((item, ind) => ({ ...item, index: ind })).filter(t => t.third_product_id === i));
			});
			var mlist = [];
			_list.forEach((i, index) => {
				mlist.push({
					id: newArr[index], // 重复商品的id
					num: i.length, // 商品重复次数
					index: Math.min(...i.map(item => item.index)), // 标记最早的商品下标
				});
			});

			// 筛选重复数大于1的商品
			this.repets = mlist.filter(item => item.num > 1);
		},
		objectSpanMethod({ row, column, rowIndex, columnIndex }) {
			if (columnIndex === 0) {
				// 查找是否有目标重复商品
				const target = this.repets.find(item => item.id === row.third_product_id);
				// 找到目标重复商品
				if (target) {
					// 找到目标下标位置，设置合并单元格个数为总重复个数
					if (rowIndex === target.index) {
						return {
							rowspan: target.num,
							colspan: 1,
						};
					} else {
						// 其余设置为0，不展示
						return {
							rowspan: 0,
							colspan: 0,
						};
					}
				} else {
					// 非目标商品一行展示
					return {
						rowspan: 1,
						colspan: 1,
					};
				}
			} else {
				// 非目标商品一行展示
				return {
					rowspan: 1,
					colspan: 1,
				};
			}
		},
		confirm() {
			this.$emit('confirmBroadcast');
			this.handleClose();
		},
	},
};
</script>

<style lang="less" scoped>
.content {
	padding: 8px;
	.el-icon-warning {
		color: rgb(250, 143, 20);
		font-size: 16px;
	}
	.text {
		color: #1d2129;
		font-size: 14px;
		line-height: 24px;
		margin-left: 6px;
	}
	.product {
		display: flex;
		.el-image {
			width: 40px;
			height: 40px;
			flex-shrink: 0;
		}
	}
}
/deep/.table-row .el-table__cell:not([rowspan='1']) {
	border-right: 1px solid #f0f1f5;
}
</style>
